import { render, staticRenderFns } from "./ReceiptGroupDetail.vue?vue&type=template&id=4f77a804&"
import script from "./ReceiptGroupDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiptGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptGroupDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports